// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rrt-button.rrt-ok-btn:active{background-color:#7293a9 !important;color:#fff}.Toastify__toast-container{padding:0;width:328px}.Toastify__toast-container--top-right{top:12px;right:90px}.Toastify__toast{font-family:var(--font-primary);font-size:var(--font-size-xsmall);font-weight:bold;border-radius:4px;min-height:3em}.Toastify__toast--error{background:var(--color-error)}.Toastify__toast--success{background:var(--color-success)}div.react-datepicker__triangle{display:none}", ""]);
// Exports
module.exports = exports;
